/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
//flow
//
import _ from 'lodash';
import React, { Component } from 'react';
import { Page, TextStyle, Banner, Stack, Link } from '@shopify/polaris';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { URL } from 'src/constants/links';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import { getThemeReviewUrl } from 'src/helpers';

type Props = {
  location: Object,
  emailSupport: string
};

type ComposedProps = Props & WithI18nProps;

class SupportedThemeSetupSuccess extends Component<ComposedProps> {
  render() {
    const themeName = _.get(this.props.location, 'state.themeName', '');
    const published = _.get(this.props.location, 'state.published', false);

    const { i18n, emailSupport } = this.props;

    return (
      <div className="BC-Page BC-Page_Success">
        <Page
          title={i18n.translate('AdminHTML.ThemeSetup.ThemeSetup.themeSetup')}
          breadcrumbs={[
            {
              content: i18n.translate('AdminHTML.ThemeSetup.ThemeSetup.themeSetup'),
              onAction: this.backToThemeSetup
            }
          ]}>
          <Banner
            title={i18n.translate('AdminHTML.ThemeSetup.ThemeSetupSuccess.title')}
            status="success"
            action={{
              content: i18n.translate('AdminHTML.ThemeSetup.ThemeSetupSuccess.preview'),
              onAction: this.handlePreview
            }}
            secondaryAction={{
              content: i18n.translate('AdminHTML.ThemeSetup.ThemeSetupSuccess.goToFAQ'),
              onAction: () => this.openLink('ThemSetupFAQ')
            }}>
            <Stack vertical={true}>
              <TextStyle>
                {i18n.translate('AdminHTML.ThemeSetup.ThemeSetupSuccess.supportedThemeContent', {
                  t1: (
                    <Link external url={URL['ThemSetupFAQ']}>
                      {i18n.translate(
                        'AdminHTML.ThemeSetup.ThemeSetupSuccess.supportedThemeContent_t1'
                      )}
                    </Link>
                  )
                })}
              </TextStyle>
              <TextStyle>
                {i18n.translate('AdminHTML.ThemeSetup.ThemeSetupSuccess.contact', {
                  nt_email: <TextStyle variation="strong">{emailSupport}</TextStyle>
                })}
              </TextStyle>
              {!published && (
                <TextStyle>
                  {i18n.translate('AdminHTML.ThemeSetup.ThemeSetupSuccess.note', {
                    nt_theme_name: <TextStyle variation="strong">{themeName}</TextStyle>
                  })}
                </TextStyle>
              )}
            </Stack>
          </Banner>
        </Page>
      </div>
    );
  }

  // Open link theme setup
  backToThemeSetup = () => {
    history.push(routes.themeSetup.view());
  };

  // Open link document in new tab
  openLink = (id: string) => {
    const newUrl = URL[id];
    window.open(newUrl, '_blank');
  };

  // Handle preview filter action
  handlePreview = () => {
    const themeId = _.get(this.props.location, 'state.themeId', '');
    const previewUrl = getThemeReviewUrl(themeId);

    window.open(previewUrl, '_blank');
    history.push(routes.themeSetup.view());
  };
}

const mapStateToProps = (state, props) => ({
  emailSupport: _.get(state.oauth, 'emailSupport')
});

export default connect(mapStateToProps, {})(withI18n()(SupportedThemeSetupSuccess));
